// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"61231d388644c421","2931":"5ad0e383543f516c","3877":"044a08e634b9f34c","3917":"61ecc9753a352839","4316":"890f6f4190c9fdfb","6908":"96676501e55f8fec"}[chunkId] + ".js";
};